// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__8p+N+","box":"style_box__xghq4","active":"style_active__SWLeV","title":"style_title__o-o-1","item":"style_item__dPyQj"};